module.exports = __webpack_public_path__ + "static/media/wittledefender_logo_cn@2x.58e99fed.png";